import { makeStyles } from '@material-ui/core/styles'

const border = {
  width: '95%',
  cursor: 'pointer',
  borderStyle: 'solid',
  borderWidth: '3px',
  borderRadius: '0.3rem',
  marginBottom: '1rem'
}

export const themePickerStyle = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  themes: {
    width: '100%',
    color: theme.palette.geoColors.text.light,
    lineHeight: '1.3rem',
    marginTop: 10
  },
  actions: {
    height: 50,
    textAlign: 'center'
  },
  themeText: {
    paddingLeft: '0.5rem',
    paddingRight: '1rem',
    cursor: 'pointer'
  },
  closeButton: {
    color: theme.palette.primary.main
  },
  iceAgeImage: {
    ...border,
    borderColor: theme.palette.dataThemeIceAge.main
  },
  climateBorder: {
    ...border,
    borderColor: theme.palette.dataThemeClimate.main
  },
  energyBorder: {
    ...border,
    borderColor: theme.palette.dataThemeEnergy.main
  },
  environmentBorder: {
    ...border,
    borderColor: theme.palette.dataThemeEnvironment.main
  },
  nnfImage: {
    position: 'relative',
    float: 'right',
    height: 36,
  }
}))
